module.exports = __webpack_public_path__ + "static/media/genwest-large-banner-image-1x.c170c42d.jpg";